import gql from 'graphql-tag';

export const Good360ListQuery = gql`
	query Good360ListQuery(
		$first: Int
		$cursor: String
		$filter: Good360FilterInput
	) {
		entities: good360s(first: $first, after: $cursor, filter: $filter) {
			edges {
				node {
					id
					localId
					status
					Good {
						id
						name
					}
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;